import { FC, ReactNode } from 'react';

import { Box } from '../../../box/components/Box/Box';
import { Divider } from '../../../divider/components/Divider/Divider';
import useId from '../../../../hooks/useId/useId';

interface Props {
   header: ReactNode;
   body?: ReactNode;
   open?: boolean;
   attributes?: Record<string, string>;
   onHeaderClick?: () => void;
}

export const Accordion: FC<Props> = ({ header, body, open = false, attributes, onHeaderClick }) => {
   const bodyId = useId(undefined, 'accordion-body');

   return (
      <>
         <Box spacing={{ x: 'md' }} direction="column" attributes={attributes}>
            <button
               type="button"
               data-testid="accordion-header"
               aria-expanded={open}
               aria-controls={body ? bodyId : undefined}
               onClick={() => onHeaderClick?.()}
            >
               {header}
            </button>
            {body && (
               <div
                  id={bodyId}
                  data-testid="accordion-body"
                  aria-hidden={!open}
                  style={open ? undefined : { display: 'none' }}
                  className="gap-component-surfaces-accordion-container-spacing-gap flex w-full flex-col"
               >
                  {body}
               </div>
            )}
         </Box>
         <Divider />
      </>
   );
};
